import { useQuery } from 'react-query'
import { getInitialState } from '../apiModules/initialState'

export const useFetchInitialState = ({ candidateProfileId, setInitialReduxState }) => {
  const { data, status } = useQuery(['initialState', candidateProfileId], () => getInitialState(candidateProfileId), {
    refetchOnWindowFocus: false,
    onSuccess: initialState => {
      setInitialReduxState(initialState)
    },
    enabled: Boolean(candidateProfileId),
  })

  return { data, status }
}
